const gophotoIcon = `
<?xml version="1.0" encoding="UTF-8"?>
<svg width="20px" height="24px" viewBox="0 0 20 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 57.1 (83088) - https://sketch.com -->
    <title>file-format-jpg-1</title>
    <desc>Created with Sketch.</desc>
    <g id="Settings-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="DB-Settings--PS--Collage-Edit" transform="translate(-789.000000, -578.000000)">
            <g id="Group-10-Copy" transform="translate(309.000000, 399.000000)">
                <g id="Group-8" transform="translate(0.000000, 42.000000)">
                    <g id="Group-6" transform="translate(23.000000, 15.000000)">
                        <g transform="translate(457.000000, 121.000000)" id="file-format-jpg-1">
                            <g transform="translate(0.000000, 1.000000)">
                                <g id="Outline_Icons" stroke="#C9CCCD" stroke-linecap="round" stroke-linejoin="round">
                                    <g id="Group">
                                        <path d="M16.359,14.5 C16.191,13.754 15.812,13.5 15,13.5 C13.742,13.5 13.5,14.535 13.5,16 C13.5,17.462 13.742,18.5 15,18.5 C16.048,18.5 16.42,17.622 16.5,16.5 L15,16.5" id="Path"></path>
                                        <g id="Path">
                                            <polygon points="19.5 23.5 0.5 23.5 0.5 0.5 13.5 0.5 19.5 6.5"></polygon>
                                            <polyline points="13.5 0.5 13.5 6.5 19.5 6.5"></polyline>
                                        </g>
                                        <path d="M9.5,18.499 L9.5,13.5 L10.75,13.5 C11.44,13.5 12,14.06 12,14.75 C12,15.44 11.44,16 10.75,16 L9.5,16" id="Path"></path>
                                        <path d="M3.5,17 C3.5,17.829 4.172,18.5 5,18.5 C5.828,18.5 6.5,17.829 6.5,17 L6.5,13.5" id="Path"></path>
                                    </g>
                                </g>
                                <g id="Invisible_Shape">
                                    <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
    `;

export default gophotoIcon;
